const Timeouts = {
  // number of hours after which a warning about a possible connectivity issue is shown in case of missing updates
  ASSET_OFFLINE_WARNING_HOURS: 24,
};

export default Timeouts;
